import React, { ElementType, forwardRef, ReactNode } from 'react'
import classNames from 'classnames'

export interface InputGroupTextProps extends React.HTMLAttributes<HTMLElement> {
    className?: string
    tag?: ElementType
    children?: ReactNode
    type?: string //in case the tag is a button
}

export const InputGroupText = forwardRef<
    HTMLElement,
    InputGroupTextProps
>(({
    tag: Tag = 'span',
    className,
    children,
    ...otherProps
}, ref) => {
    const classes = classNames('input-group-text', className)

    return (
        <Tag
            ref={ref}
            className={classes}
            {...otherProps}
        >
            {children}
        </Tag>
    )
})

InputGroupText.displayName = 'InputGroupText'
